<template>
    <div class="ele-page flex-n fac fje">
        <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="currentPage"
                :pager-count="7"
                :page-sizes="[10, 20, 50, 100]"
                :page-size="pageSize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="total">
        </el-pagination>
    </div>
</template>

<script>
    export default {
        name: "pagination",
        props:{
            pageSize:Number,
            total:Number,
            currentPage:Number
        },
        methods:{
            handleSizeChange(val) {
                this.$emit('sizeChange',val);
            },
            handleCurrentChange(val) {
                console.log(val)
                this.$emit('currentChange',val);
            }
        }
    }
</script>

<!--<style scoped lang="scss">-->
<!--&lt;!&ndash;.pagination{&ndash;&gt;-->
    <!--&lt;!&ndash;position: fixed;&ndash;&gt;-->
    <!--&lt;!&ndash;bottom: 0px;&ndash;&gt;-->
    <!--&lt;!&ndash;/*width: 100%;*/&ndash;&gt;-->
    <!--&lt;!&ndash;right: 0px;&ndash;&gt;-->
    <!--&lt;!&ndash;height: 50px;&ndash;&gt;-->
    <!--&lt;!&ndash;background: white;&ndash;&gt;-->
    <!--&lt;!&ndash;z-index: 10;&ndash;&gt;-->
    <!--&lt;!&ndash;box-shadow: 10px -10px 10px #eeeeee;&ndash;&gt;-->
    <!--&lt;!&ndash;}&ndash;&gt;-->
<!--</style>-->